module.exports = __webpack_public_path__ + "img/product-img.c74ebf85.png";